<template>

    <VCalendar
      ref="calendar"
      data-testid="my-calendar.left-calendar.mini-calendar"
      title-position="right"
      :attributes='attrs'
      color="vibrant-blue"
      class="mini-calendar"
      
      @dayclick="handleDayclick">

      <template #header-prev-button >
        <img data-testid="my-calendar.left-calendar.prev-month-icon" class="w-3 h-3" src="@/assets/my-calendar/calendar/calendar-left-arrow.svg"  alt="prevIcon" />

      </template>

      <template #header-next-button>
        <img data-testid="my-calendar.left-calendar.next-month-icon" class="w-3 h-3 rotate-180" src="@/assets/my-calendar/calendar/calendar-left-arrow.svg" alt="nextIcon" />

      </template>
    </VCalendar>

</template>

<script setup>
import _ from 'lodash';
import { ref, watch } from 'vue';

const calendar = ref(null);
const emit = defineEmits(['move-to-date'])
const props = defineProps({
  moveDate: {
    type: [String, Date, Object],
    default: () => new Date()
  }
})

const attrs = ref([
  {
    key: 'clicked',
    highlight: true,
    dates: new Date(),
  },
]);

const handleDayclick = (day) => {
  _.remove(attrs.value, i => i.key === 'clicked')
  attrs.value.push({
    key: 'clicked',
    highlight: {
      color: '#004879',
      fillMode: 'solid',
    },
    dates: day.date
  })
  // console.log('handleDayclick', day.id)
  emit('move-to-date', day.id)
}

watch(() => props.moveDate, (newDate) => {
  if (!newDate) return;
  
  // Remove previous highlight
  attrs.value = _.reject(attrs.value, i => i.key === 'clicked');
  
  // Handle different date types from main calendar
  if (typeof newDate === 'object' && newDate.type) {
    if (newDate.type === 'week') {
      // Highlight entire week range
      // Add 'T00:00:00' to force local timezone parsing instead of UTC
      const start = new Date(newDate.start + 'T00:00:00');
      const end = new Date(newDate.end + 'T00:00:00');
      
      attrs.value.push({
        key: 'clicked',
        highlight: {
          color: '#004879',
          fillMode: 'solid',
        },
        dates: { start, end }
      });
      calendar.value.move(start);
    } else if (newDate.type === 'day') {
      // Highlight specific day
      const date = new Date(newDate.date + 'T00:00:00');
      
      attrs.value.push({
        key: 'clicked',
        highlight: {
          color: '#004879',
          fillMode: 'solid',
        },
        dates: date
      });
      calendar.value.move(date);
    } else if (newDate.type === 'month') {
      // Highlight first day of month
      const date = new Date(newDate.date + 'T00:00:00');
      
      attrs.value.push({
        key: 'clicked',
        highlight: {
          color: '#004879',
          fillMode: 'solid',
        },
        dates: date
      });
      calendar.value.move(date);
    }
  } else {
    // Fallback for old format (string date)
    attrs.value.push({
      key: 'clicked',
      highlight: true,
      dates: new Date(newDate)
    });
    calendar.value.move(newDate);
  }
})

</script>


<style scoped>

</style>
